import { render, staticRenderFns } from "./WrhousCodeRegistrationPopup.vue?vue&type=template&id=4a87ecfe&scoped=true&"
import script from "./WrhousCodeRegistrationPopup.vue?vue&type=script&lang=js&"
export * from "./WrhousCodeRegistrationPopup.vue?vue&type=script&lang=js&"
import style0 from "./WrhousCodeRegistrationPopup.vue?vue&type=style&index=0&id=4a87ecfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a87ecfe",
  null
  
)

export default component.exports